import {
  useMutation,
  type UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { queryKeysCompany } from '../queryKeys';

import { UpdateCompanyAiSettingsPayload } from './types';
import { updateCompanyAiSettings } from './updateCompanyAiSettings';

/**
 * Custom hook for updating a company's AI model settings using mutations.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company/operation/set_ai_model_settings_vadmin_company__company_id__default_ai_model_settings_put
 */
export const useMutationUpdateCompanyAiSettings = (
  options?: Omit<UseMutationOptions, 'mutationFn'>,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      companyId,
      aiModelSettings,
    }: UpdateCompanyAiSettingsPayload) =>
      updateCompanyAiSettings(companyId, aiModelSettings),
    onSettled(_data, _error, { companyId }) {
      void queryClient.invalidateQueries({
        queryKey: queryKeysCompany.getAiSettings(companyId),
      });
    },
    ...options,
  });
};
